/**
 * 定价字段的数据加载Hook
 */

import { useState, useCallback } from 'react';
import axios from 'axios';
import { SITE_TO_COUNTRY, DEFAULT_VALUES } from '../constants/pricingConstants';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const usePricingData = (site: string) => {
    const [categories, setCategories] = useState<any[]>([]);
    const [channels, setChannels] = useState<any[]>([]);
    const [exchangeRate, setExchangeRate] = useState<number>(DEFAULT_VALUES.EXCHANGE_RATE);
    const [loading, setLoading] = useState(false);
    const [referralRate, setReferralRate] = useState<number>(DEFAULT_VALUES.REFERRAL_RATE);

    const loadCategories = useCallback(async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/amazon-categories/`, {
                params: { site, active_only: true }
            });
            const data = res.data;
            setCategories(Array.isArray(data) ? data : (data.results || []));
        } catch (error) {
            setCategories([]);
        }
    }, [site]);

    const loadExchangeRate = useCallback(async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/exchange-rates/latest/`, {
                params: { currencies: 'USD' }
            });
            const data = res.data;
            const rates = Array.isArray(data) ? data : (data.results || []);
            if (rates.length > 0) setExchangeRate(rates[0].rate);
        } catch (error) {
            console.error('获取汇率失败:', error);
        }
    }, []);

    const loadChannels = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${API_BASE_URL}/shipping-channels/`);
            const data = res.data;
            const list = Array.isArray(data) ? data : (data.results || []);

            const targetCountry = SITE_TO_COUNTRY[site];
            const filteredList = targetCountry
                ? list.filter((ch: any) => ch.destination_country === targetCountry)
                : list;

            const listWithId = filteredList.map((item: any, index: number) => ({
                ...item,
                id: item.id || index.toString()
            }));

            setChannels(listWithId);
        } catch (error) {
            setChannels([]);
        } finally {
            setLoading(false);
        }
    }, [site]);

    const loadCategoryReferralRate = useCallback(async (categoryName: string) => {
        try {
            const res = await axios.get(`${API_BASE_URL}/amazon-categories/get_referral_rate/`, {
                params: { site, category_name: categoryName }
            });
            setReferralRate(res.data.referral_fee_rate);
        } catch (error) {
            console.warn('获取佣金率失败，使用默认值 15%:', error);
            setReferralRate(15.0); // 默认 15%
        }
    }, [site]);

    return {
        // 状态
        categories,
        channels,
        exchangeRate,
        referralRate,
        loading,
        // 方法
        setExchangeRate,
        setReferralRate,
        loadCategories,
        loadExchangeRate,
        loadChannels,
        loadCategoryReferralRate,
    };
};
